import { DrawerPosition as FluentDrawerPosition, DrawerSize as FluentDrawerSize, DrawerType as FluentDrawerType } from "@fluentui/web-components";
/** Positions supported by {@link Drawer}. */
export const DrawerPositions = {
    ...FluentDrawerPosition
};
/** Size values supported by {@link Drawer}. */
export const DrawerSizes = {
    ...FluentDrawerSize
};
/** Type values supported by {@link Drawer}. */
export const DrawerTypes = {
    ...FluentDrawerType
};
//# sourceMappingURL=drawer.options.js.map